<template>
    <transition name="overlay-transition">
        <div class="overlay" v-show="shouldShow">
            <div class="overlay-slot" :class="overlaySlotClass">
                <div class="overlay-body" :class="[{'fragrance-overlay': optionTileType === 3}, {'has-scrollbar': hasScrollBar}]">
                    <slot></slot>
                </div>
            </div>

            <button class="overlay-close" @click="onClickClose">
                <span class="icon icon-close-thick"></span>
            </button>
        </div>
    </transition>
</template>

<script src='./overlay.js'></script>
